import React, { useContext, useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "./footer";
import Nabvar from "./Navbar";
import { Accordion, Card, Container } from "react-bootstrap";
import { RiArrowDropDownLine } from "react-icons/ri";
import { Helmet } from "react-helmet";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";
import { GlobalContext } from "../Context/GlobalState";

const Billpuncfaq = () => {
  const [faq, setfaq] = useState([]);
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [faqJsonLD, setFaqJsonLD] = useState("");

 
  const getfaq = async () => {
    setTransactionLoaderState(true);
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
        redirect: "follow",
      };

      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetFaqSuperadmin`,
        requestOptions
      );
      const data = await response.json();
      if (data.status === "0") {
        setfaq(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.error("Error fetching FAQ data:", error);
      setTransactionLoaderState(false);
    }
  };
  const generateFAQJsonLD = (faqData) => {
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqData.map((item) => ({
        "@type": "Question",
        "name": item.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": item.answer,
        },
      })),
    };
  
    return JSON.stringify(structuredData);
  };
  
  useEffect(() => {
    if (faq.length > 0) {
      const jsonLD = generateFAQJsonLD(faq);
      setFaqJsonLD(jsonLD);
    }
  }, [faq]);
 

  return (
    <>
     {faqJsonLD && (
  <Helmet>
    <script type="application/ld+json">
      {faqJsonLD}
    </script>
  </Helmet>
)}

      <Nabvar />
      <h1 className="text-center mt-3" style={{ color: "darkblue" }}>
        Frequently Asked Questions
      </h1>

      <div className="row mt-md-2">
        <div className="col-md-1"></div>
        <div className="col-md-6 col-10 d-flex justify-content-center col">
          <Container className="m-0 p-0">
          <Accordion>
  {faq.map((item) => (
    <Accordion.Item eventKey={String(item.pk_faq_id)} key={item.pk_faq_id}>
      <Accordion.Header>
        {item.question}
        <RiArrowDropDownLine style={{ marginLeft: "auto" }} />
      </Accordion.Header>
      <Accordion.Body>{item.answer}</Accordion.Body>
    </Accordion.Item>
  ))}
</Accordion>

          </Container>
        </div>
        <div className="col-md-5 d-flex justify-content-center mt-md-5">
          <img
            className="mainpic"
            alt="FAQs section"
            style={{ height: "20rem" }}
            src={require("../../src/Images/images/billpunch_faq.png")}
          />
        </div>
        <div className="col-md-1"></div>
      </div>

      <Footer />
    </>
  );
};

export default Billpuncfaq;
